<div class="text-end">
    <button *ngIf="order" mat-stroked-button (click)="printAllLabels()" class="me-2">
        <mat-icon>print</mat-icon> Print all labels
    </button>
</div>

<table mat-table matSort [dataSource]="orderItems" class="order-list">
    <ng-container matColumnDef="pack_size">
        <th mat-header-cell *matHeaderCellDef>Pack size</th>
        <td mat-cell *matCellDef="let item"> {{item.medicineDosagePackageType.contained_quantity}} </td>
    </ng-container>
    <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Quantity</th>
        <td mat-cell *matCellDef="let item"> {{item.quantity}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let item"> {{ item.medicineDosagePackageType.label_name }} </td>
    </ng-container>

    <ng-container matColumnDef="dosage">
        <th mat-header-cell *matHeaderCellDef>Dosage</th>
        <td mat-cell *matCellDef="let item"> {{ item.dosageType.additional_information }} </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let item">
            <p class="status">
                <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select [value]="getStatus(item)" [disabled]="isLoading"
                        (selectionChange)="changeOrderItemStatus($event, item)">
                        <mat-option *ngFor="let status of orderItemStatuses" [value]="status">
                            {{status.status}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </p>
        </td>
    </ng-container>

    <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let item">
            <p class="price">R {{ getTotalPrice(item) }}</p>
        </td>
    </ng-container>

    <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let item">

            <div class="row">

                <div class="col-6">
                 
                    <button color="warn" (click)="deleteOrderItem(item)" mat-stroked-button>
                        <mat-icon>delete_outline</mat-icon> Remove
                    </button>

                </div>


                <div class="col-6 text-end">

                    <button *ngIf="order" mat-stroked-button (click)="printLabels([item])" class="me-2">
                        <mat-icon>print</mat-icon> Print labels
                    </button>

                </div>

            </div>

        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>